// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import SimpleModal from 'Common/SimpleModal';
import { Bling as GPT } from 'react-gpt';
import { Grid, Row, Col } from 'Common/Grid';
import KeyFacts from './KeyFacts';
import Specifications from './Specifications';
import DealerInfo from 'Common/DealerInfo';
import DealerForm from './DealerForm';
import Button from 'Common/Button';
import { dealer } from 'Common/dealer';
import Gallery from 'Common/Gallery';
import GalleryModal from 'Common/GalleryModal';
import Accordion from 'Common/Accordion';
import SEO from 'Common/Seo';
import * as Actions from 'actionTypes';
import {
  slots,
  createAdUnitPath,
  targetingDetail,
  adUnitPageNames
} from 'Common/ads';
import styles from 'rootContainer/Detail.scss';
import CardsCarousel from 'Common/CardsCarousel';
import isWindow from 'Common/isWindow';
import isWindowProp from 'Common/isWindowProp';
import { gtmDetails, gtmDisplayDetails, gtmPageview } from 'Common/gtmPayloads';
import scrollToTopOfPage from 'Common/scrollToTopOfPage';
import { redirectUrl } from './redirectUrl';
import metadata from 'App/variables/seo';
import classNames from 'classnames';
import BreadCrumb from 'Common/BreadCrumb';
import WithSticky from 'Common/HOC/WithSticky';
import WithStickyRender from 'Common/WithStickyRender';
import StickyCta from './StickyCta';
import objectExistsAndHasProps from './objectExistsAndHasProps';
import slugify from 'slugify';
import PartnershipLogo from 'Common/PartnershipLogo';
import { gtmEventPush } from 'utils/gtm/events';
import { getDerivativeDisplayName } from 'utils/derivative';
import shortenStringWithSuffix from 'utils/shortenStringWithSuffix';
import NavBar from './NavBar';

const StickyCtaBottom = WithSticky(StickyCta, 'bottom');
const PROPOSITION_STATEMENTS = [
  'Each car quality checked',
  'All cars come with a warranty',
  'Each car is under 8 years old and has less than 100,000 miles',
  'Each car checked for history, accidents and more',
  'Buy from selected dealers, chosen by us'
];

// Helpers

/**
 * < contained same time toDetail /> component.
 * @param {string} classifiedId - classifiedId
 * @return {class} returns detail instance
 */
export class Detail extends Component<*, *> {
  stickyElement: ?HTMLElement;

  /**
   * @param {object} props - props passed
   */
  constructor(props: Object) {
    super(props);
    this.changeImage = this.changeImage.bind(this);
    this.backToListings = this.backToListings.bind(this);
    this.state = {
      formType: 'message',
      enquiryModal: false,
      DOMelement: null,
      vehicleDescriptionModal: false
    };
  }

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      item: state.listing,
      isMatch: state.listing.isMatch,
      isLoading: state.listing.isLoading,
      lastList: state.results.url,
      isModalOpen: state.ui.isModalOpen,
      viewport: state.viewport.viewport,
      isError: state.ui.error,
      lastPostCode: state.ui.lastPostCode,
      related: state.listing.related
    };
  }

  pushPv = () => {
    if (
      isWindow() &&
      isWindowProp('dataLayer') &&
      isWindowProp('location') &&
      !this.props.item.isLoading
    ) {
      window.dataLayer.push(
        gtmPageview(
          'Detail',
          global.window.location.pathname,
          'Classifieds Advert Listing Page'
        )
      );
      clearInterval(this.interval);
    }
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    if (isWindow() && isWindowProp('dataLayer')) {
      window.dataLayer.push({ page: '' });
    }
  }

  /* eslint-disable camelcase */
  /**
   * UNSAFE_componentWillMount it fetches the deal.
   * @param {string} classifiedId - classifiedId
   * @return {void}
   */
  UNSAFE_componentWillMount() {
    this.props.dispatch({
      type: Actions.FETCH_LISTING,
      id: this.props.match.params.id,
      postCode: this.props.lastPostCode
    });
  }

  componentDidMount() {
    // Set reference element
    this.setState({
      DOMelement: this.stickyElement
    });
    scrollToTopOfPage();
    GPT.enableSingleRequest();
    this.interval = setInterval(this.pushPv, 300);
  }

  setDealerFormType = (formType: string) => {
    this.setState({ formType });
  };

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      isWindow &&
      isWindowProp('dataLayer') &&
      isWindowProp('location') &&
      !nextProps.item.isLoading &&
      nextProps.isLoading !== this.props.isLoading &&
      !nextProps.isError
    ) {
      window.dataLayer.push(gtmDetails(nextProps.item));
      if (nextProps.item.related) {
        window.dataLayer.push(gtmDisplayDetails(nextProps.item));
      }
    }

    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.props.dispatch({
        type: Actions.FETCH_LISTING,
        id: nextProps.match.params.id,
        postCode: nextProps.lastPostCode
      });
      scrollToTopOfPage();
    }

    if (!nextProps.isMatch && nextProps.isMatch !== undefined) {
      this.props.history.push(redirectUrl(this.props.match.url));
    }

    if (
      objectExistsAndHasProps(nextProps.item, [
        'derivative',
        'dealer',
        'cashPrice'
      ]) &&
      !this.state.gptInitialised
    ) {
      targetingDetail(nextProps.item.derivative);
      this.setState({ gptInitialised: true });
    }
  }

  changeImage() {
    GPT.refresh([this.galleryAd.adSlot]);
  }

  backToListings() {
    gtmEventPush({
      method: 'backToListings',
      args: {}
    });
    this.props.lastList
      ? this.props.history.push(this.props.lastList)
      : this.props.history.push(redirectUrl(this.props.match.url));
  }

  openEnquiryModal = type => {
    const { dispatch, isModalOpen } = this.props;

    // if the gallery is open, ensure that gets closed
    if (isModalOpen) {
      // Opinionated gallery means I have to do this, unless re-jigged somehow.
      document.body.style.overflow = 'visible';
      dispatch({ type: Actions.CLOSE_MODAL });
    }

    this.setState({ enquiryModal: true, formType: type });
  };

  closeEnquiryModal = () => {
    this.setState({ enquiryModal: false });

    gtmEventPush({
      method: 'closeEnquiryModal',
      args: {}
    });
  };

  handleVehicleDescriptionModal = () => {
    const { vehicleDescriptionModal } = this.state;
    this.setState({ vehicleDescriptionModal: !vehicleDescriptionModal });
  };

  pushGtmCTA = action => {
    const make = _get(this.props, ['item', 'derivative', 'make']);
    const range = _get(this.props, ['item', 'derivative', 'range']);
    const sourceId = _get(this.props, ['item', 'sourceId']);

    gtmEventPush({
      method: 'detailsCTA',
      args: {
        actionPrefix: 'Desktop sticky:',
        action: action,
        sourceId: `${make}/${range}/${sourceId}`
      }
    });
  };

  /**
   * Renders the detail page.
   *
   * @return {JSX} about html.
   */
  render(): Element<*> | null {
    const { enquiryModal, vehicleDescriptionModal } = this.state;

    const valueOrNA = value => value || 'N/A';
    const isSmallDevice =
      this.props.viewport === 'xs' ||
      this.props.viewport === 'sm' ||
      this.props.viewport === 'md' ||
      false;

    const isMobile =
      this.props.viewport === 'xs' || this.props.viewport === 'sm';

    const headline =
      this.props.item &&
      this.props.item.derivative &&
      getDerivativeDisplayName(this.props.item.derivative);

    const price =
      this.props.item &&
      this.props.item.totalPrice &&
      this.props.item.totalPrice !== 999999999
        ? `£${valueOrNA(
            parseInt(this.props.item.totalPrice).toLocaleString('en')
          )}`
        : 'POA';

    const {
      classDetail,
      classDetailLoading,
      classDetailPrice,
      classSpecificationsContainer,
      classDetailCarouselItems,
      classDetailCentered,
      classModalClose,
      headerAd,
      mtxl,
      mtm,
      mts
    } = styles;

    const carouselItemsToDisplay = { xs: 1, sm: 2, md: 3, lg: 4 };

    let make =
      this.props.item &&
      this.props.item.derivative &&
      this.props.item.derivative.make
        ? this.props.item.derivative.make
        : '';

    let model =
      this.props.item && this.props.item.derivative
        ? this.props.item.derivative.range
        : '';

    const adProps = {
      page: adUnitPageNames['detail'],
      make,
      model
    };

    const galleryAdProps = {
      page: 'gallery',
      make,
      model
    };

    const shareUrl = `${process.env.BASE_URL}${this.props.match.url}`;

    // TODO: It's ridiculous to mutate a component's own props like this!
    this.props.item.url = this.props.item ? shareUrl : null;
    this.props.item.qs = this.props.location.search;

    // Social
    const shareImg =
      this.props &&
      this.props.item &&
      this.props.item.images &&
      this.props.item.images[0] &&
      this.props.item.images[0].image &&
      this.props.item.images[0].image.lg
        ? this.props.item.images[0].image.lg.replace('//qa-img', 'https://img')
        : `${process.env.BASE_URL}/images/fallback.png`;

    const county =
      this.props && this.props.item && this.props.item.dealer
        ? this.props.item.dealer.county
        : '';

    const meta = metadata.listing(
      headline,
      county,
      this.props.match.url,
      shareImg
    );

    meta.schema = {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: `Used ${make || null} ${model || null} for sale on What Car?`,
        description: `Find and buy your perfect used ${make || null} ${model |
          null} cars with What Car? Classifieds, the easiest and most powerful used car search around`,
        speakable: {
          '@type': 'SpeakableSpecification'
        },
        url: `${process.env.BASE_URL}/used-cars/${!make ||
          slugify(make)}/${!model || slugify(model)}`,
        publisher: {
          '@type': 'Organization',
          name: 'What Car?',
          parentOrganization: 'Haymarket Automotive'
        }
      })
    };

    const { related, item } = this.props;
    const relatedCars =
      (related && related.filter(_ => _.sourceId !== item.sourceId)) || [];

    return (
      <div
        className={classNames(
          classDetail,
          this.props.isLoading ? classDetailLoading : null
        )}
      >
        <SEO {...meta} />
        <Grid>
          <Row>
            <Col colXs={12}>
              <BreadCrumb breadCrumbUrl={this.props.match.url} />

              <div className={styles.headingContainer}>
                <h1>{headline}</h1>
                <div className={styles.buttonContainer}>
                  <Button
                    buttonText={'Back to listings'}
                    type="secondary"
                    size="small"
                    onClick={this.backToListings}
                    attributeTarget="_self"
                    extendStyle={mts}
                  />
                  <PartnershipLogo />
                </div>
              </div>

              <div className={styles.headerAd}>
                <GPT
                  id={slots.header.id}
                  adUnitPath={createAdUnitPath(adProps)}
                  collapseEmptyDiv={true}
                  renderWhenViewable={false}
                  sizeMapping={slots.header.sizeMapping}
                  targeting={slots.header.targeting}
                />
              </div>
            </Col>
          </Row>

          <SimpleModal isModalOpen={enquiryModal}>
            <div className={classModalClose}>
              <button onClick={this.closeEnquiryModal} />
            </div>
            <DealerForm
              item={this.props.item}
              subject={headline}
              postCode={this.props.lastPostCode}
              formType={this.state.formType}
              changeFormType={this.setDealerFormType}
              onSuccess={this.closeEnquiryModal}
              make={make}
              model={model}
              price={price}
            />
          </SimpleModal>
          <SimpleModal isModalOpen={vehicleDescriptionModal}>
            <div className={classModalClose}>
              <button onClick={this.handleVehicleDescriptionModal} />
            </div>
            <div className={styles.vehicleDescriptionModalContent}>
              <h5>Vehicle description</h5>
              <div className={styles.vehicleContent}>
                {this.props.item.description}
              </div>
              <Button
                onClick={this.handleVehicleDescriptionModal}
                buttonText={'Close'}
                extendStyle={styles.closeButton}
                size={'large'}
                type={'transparent'}
              />
            </div>
          </SimpleModal>
          {!this.props.isError && (
            <Row className={mts}>
              <Col colXs={12} colSm={12} colMd={8} colLg={8}>
                {this.props.isModalOpen &&
                  this.props.item &&
                  this.props.item.images &&
                  this.props.item.dealer && (
                    <GalleryModal
                      pictures={this.props.item.images}
                      dealer={dealer(this.props)}
                      headline={headline}
                      price={price}
                      showCaption={false}
                      galleryAdvertImage={
                        'http://via.placeholder.com/300x250?text=MPU+300x250'
                      }
                      onChange={this.changeImage}
                      setDealerFormType={this.setDealerFormType}
                      buttonOnClick={this.openEnquiryModal}
                      gtmSectionName={'gallery'}
                    >
                      <GPT
                        id={slots.gallery.id}
                        ref={el => (this.galleryAd = el)}
                        adUnitPath={createAdUnitPath(galleryAdProps)}
                        collapseEmptyDiv={true}
                        sizeMapping={slots.gallery.sizeMapping}
                        targeting={slots.gallery.targeting}
                      />
                    </GalleryModal>
                  )}
                {!this.props.isModalOpen &&
                  this.props.item &&
                  this.props.item.images && (
                    <div className={mts}>
                      <Gallery
                        pictures={this.props.item.images}
                        showCaption={true}
                      />
                    </div>
                  )}
              </Col>
              <Col colXs={12} colSm={12} colMd={4} colLg={4}>
                <div ref={refToChild => (this.stickyElement = refToChild)}>
                  <div className={styles.priceContainer}>
                    <h4>Key facts </h4>
                    <h2 className={classNames([classDetailPrice, mts])}>
                      {price}
                    </h2>
                  </div>
                  <KeyFacts />
                  <DealerInfo
                    changeFormTypeFunc={this.setDealerFormType}
                    gtmSectionName="Sidebar"
                    buttonOnClick={this.openEnquiryModal}
                  />
                </div>
              </Col>
            </Row>
          )}
          {!this.props.isError && (
            <Row className={mtm}>
              <Col colXs={12} colSm={12} colMd={8} colLg={8}>
                <div className={styles.vehicleDescription}>
                  <div>
                    <h5>Vehicle description</h5>
                    <div className={styles.vehicleContent}>
                      {shortenStringWithSuffix(
                        this.props.item.description,
                        400,
                        '...'
                      )}
                    </div>
                    <a
                      onClick={this.handleVehicleDescriptionModal}
                      className={styles.readMore}
                    >
                      Read all
                    </a>
                  </div>
                  <div className={styles.propositionStatement}>
                    <h5>We promise confidence with every car</h5>
                    <ul className={styles.vehicleContent}>
                      {PROPOSITION_STATEMENTS.map((item, i) => {
                        return <li key={`propStatement{$i}`}>{item}</li>;
                      })}
                    </ul>
                  </div>
                </div>
                <div className={classSpecificationsContainer}>
                  <Specifications specificationsName={'runningCosts'} />
                  <Specifications specificationsName={'performance'} />
                  <Accordion
                    accordionHeight={0}
                    accordionTitle=""
                    accordionControl={'toggle'}
                    toggleTitles={[
                      'More Specifications',
                      'Less Specifications'
                    ]}
                    gtmSectionName={'accordionSpecification'}
                  >
                    <Specifications specificationsName={'exterior'} />
                    <Specifications specificationsName={'interior'} />
                    <Specifications specificationsName={'fuel'} />
                    <Specifications specificationsName={'transmission'} />
                  </Accordion>
                </div>
              </Col>
              <Col colXs={12} colSm={12} colMd={4} colLg={4}>
                <div className={classNames([classDetailCentered, headerAd])}>
                  <GPT
                    id={slots.sidenav.id}
                    adUnitPath={createAdUnitPath(adProps)}
                    renderWhenViewable={false}
                    collapseEmptyDiv={true}
                    sizeMapping={slots.sidenav.sizeMapping}
                    targeting={slots.sidenav.targeting}
                  />
                </div>
              </Col>
            </Row>
          )}
          {!this.props.isError && (
            <Row className={mtxl}>
              <Col colXs={12}>
                <CardsCarousel
                  carouselItemsToDisplay={carouselItemsToDisplay}
                  extendStyle={classDetailCarouselItems}
                  title={'Also consider'}
                  history={this.props.history}
                  related={relatedCars}
                  gtmSectionName={'alsoConsider'}
                />
              </Col>
            </Row>
          )}
        </Grid>
        {!enquiryModal && isSmallDevice && (
          <StickyCtaBottom
            phoneNumber={
              this.props.item.dealer && this.props.item.dealer['encodedNo']
                ? this.props.item.dealer['encodedNo']
                : null
            }
            item={this.props.item}
            openEnquiryModal={this.openEnquiryModal}
          />
        )}
        {this.state.DOMelement && !isMobile && (
          <WithStickyRender
            extendStyleFixed={styles.extendStickyClassFixed}
            DOMElemRef={this.state.DOMelement}
            isStickyOnScroll
            position={'topLeft'}
            extendStyleInit={styles.hideNavigation}
            extendStyle={styles.extendclassWithStickyBoxShadow}
            render={() => {
              return (
                <NavBar
                  title={headline}
                  image={this.props.item.images && this.props.item.images[0]}
                  price={price}
                  phoneNumber={
                    this.props.item.dealer &&
                    this.props.item.dealer['encodedNo']
                      ? this.props.item.dealer['encodedNo']
                      : undefined
                  }
                  pushGtmCTA={this.pushGtmCTA}
                  buttonOnClick={this.openEnquiryModal}
                />
              );
            }}
          />
        )}
      </div>
    );
  }
}

export default connect(Detail.mapStateToProps)(Detail);



// WEBPACK FOOTER //
// ./src/Detail/index.js